import { getCampaignEntity, FORM_MODES } from 'modules/campaigns/config';
import { generateCampaignEditorPath } from 'modules/campaigns/services/utils';
import { dimensionSelector, selectedAccountSelector } from 'selectors';

const duplicateCampaign = (rowData, navigate) => (_, getState) => {
    const { accountName } = rowData;
    const state = getState();
    const { accountId: selectedAccountId } = selectedAccountSelector(state);
    const dimension = dimensionSelector(state);
    const accountId = accountName || selectedAccountId;
    const entity = getCampaignEntity(rowData);
    // TODO: should take "rowData.id" in a generic way, so if the name of the field changes we wont need to change the code. Example: rowData[FIELDS.ID.field].
    const duplicateCampaignPath = generateCampaignEditorPath({
        mode: FORM_MODES.DUPLICATE,
        accountId,
        campaignId: rowData.id,
        dimension,
        entity,
    });

    navigate(duplicateCampaignPath);
};

export default duplicateCampaign;
